<template>

    <router-view></router-view>

</template>


<script>
export default {
  name: "SocietyModule",
  components: {},
  data: () => ({}),
};
</script>
